<template>
  <div id="app">
    <simple-beautiful-phone />
  </div>
</template>

<script>
import SimpleBeautifulPhone from './components/SimpleBeautifulPhone';

export default {
  name: 'App',
  components: {
    SimpleBeautifulPhone
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
